/* expander.tsx generated by @compiled/babel-plugin v3.0.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1kOSYtLaAG%7Btransition-property%3Amax-height%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3Z9K0wqvoi%7Btransition-duration%3Avar(--ds-duration-long%2C.25s)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(prefers-reduced-motion%3Areduce)%7B._2Iz54kUiLg%7Btransition-duration%3A0s%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._23rrnHpA9h%7Btransition%3Amax-height%20.3s%7D");
import { cx } from '@atlaskit/css';
import ExitingPersistence from '@atlaskit/motion/exiting-persistence';
import FadeIn from '@atlaskit/motion/fade-in';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box, Stack } from '@atlaskit/primitives/compiled';
const styles = {
  expander: "_39xV02N91d",
  expanderTransition: "_1kOSYtLaAG _3Z9K0wqvoi _2Iz54kUiLg",
  expanderCollapsed: "_4bt5LAnQyn _2WAcuGnQyn",
  container: "_23rrnHpA9h"
};
type ExpanderProps = {
  isExpanded: boolean;
  testId?: string;
  children: React.ReactNode;
};
const Expander = ({
  children,
  isExpanded,
  testId
}: ExpanderProps): JSX.Element => {
  const isCollapseAnimationEnabled = fg('platform-dst-flag-collapse-animation-fix');

  // Need to always render the ExpanderInternal otherwise the
  // reveal transition doesn't happen. We can't use CSS animation for
  // the the reveal because we don't know the height of the content.

  return <Box xcss={cx(styles.expander, isCollapseAnimationEnabled && styles.expanderTransition, isCollapseAnimationEnabled && !isExpanded && styles.expanderCollapsed)} style={{
    maxHeight: isExpanded ? 150 : 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    flex: '1 1 100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    minWidth: 0
  }} aria-hidden={!isExpanded} testId={testId && `${testId}-expander`}>
			<ExitingPersistence appear>
				{isExpanded && <FadeIn>
						{props => <Box xcss={cx(!isCollapseAnimationEnabled && styles.container)} {...props}>
								<Stack space="space.100">{children}</Stack>
							</Box>}
					</FadeIn>}
			</ExitingPersistence>
		</Box>;
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Expander;